/** Sub config for one multibook entrance */
export default {
  /** disable bookindex Icon */
  showBookIndexIcon: true,
};
